export class PredefinedMessageModel {
  _id?: any;
  uuid: string;
  message_body: string;
  message_type: string;
  channel_type: string;
  template_type?: string;
  message_name?: string;
  create_date?: Date;
  update_date?: Date;
  created_by?: string;
  updated_by?: string;
  revision?: string;
  status?: string;
  vrsn?: string;
}
